module.exports = __webpack_public_path__ + "img/cpzz3@2x.b8a138e4.png";